import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6524e2af")
const _hoisted_1 = {
  key: 0,
  class: "carddoor"
}
const _hoisted_2 = { ref: "c" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "summary" }
const _hoisted_5 = { class: "_reviews" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "text" }, " How was your experience? ", -1)
const _hoisted_7 = { class: "emojis" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  class: "card"
}
const _hoisted_12 = { class: "answer" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", null, "The final step", -1)
const _hoisted_14 = { class: "question" }
const _hoisted_15 = { class: "inputs" }
const _hoisted_16 = { class: "buttons" }
const _hoisted_17 = {
  key: 1,
  class: "answerText"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "answerMarker" }, "Answer:", -1)
const _hoisted_19 = {
  key: 0,
  class: "indicators"
}
const _hoisted_20 = { class: "indicator" }
const _hoisted_21 = { class: "_icon tick" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Correct ")
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "topGraphic _img exitMissing" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "_giveMeSpace" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "You still haven't found the exit."),
  /*#__PURE__*/_createElementVNode("p", null, "Hurry! Best go back and keep looking!")
], -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Room = _resolveComponent("Room")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_ctx.$store.state.GameView.lobby.playthrough && _ctx.$store.state.GameView.playthrough.atdoor)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("canvas", _hoisted_2, null, 512),
        _createElementVNode("div", {
          class: _normalizeClass({
      doorDisplay:true,
      chest:_ctx.$store.state.GameView.game.exitType,
      large:
        _ctx.$store.state.GameView.lobby.playthrough.cardStatus 
        && _ctx.$store.state.GameView.lobby.playthrough.cardStatus['door']?.correct
    })
        }, [
          (_ctx.$store.state.GameView.game.exitType == 1)
            ? (_openBlock(), _createBlock(_component_Room, {
                key: 0,
                rotatable: true,
                slowRotate: true,
                properties: _ctx.chestRoomData,
                escaped: _ctx.$store.state.GameView.lobby.playthrough.finished,
                onEscaped: _ctx.escaped
              }, null, 8, ["properties", "escaped", "onEscaped"]))
            : (_ctx.$store.state.GameView.game.exitType == 0)
              ? (_openBlock(), _createBlock(_component_Room, {
                  key: 1,
                  rotatable: true,
                  slowRotate: true,
                  properties: _ctx.doorRoomData,
                  escaped: _ctx.$store.state.GameView.lobby.playthrough.finished,
                  onEscaped: _ctx.escaped
                }, null, 8, ["properties", "escaped", "onEscaped"]))
              : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.$store.state.GameView.lobby.playthrough.finished)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$store.state.GameView.game.victoryMessage || "You escaped!"), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h3", null, "Time taken: " + _toDisplayString(_ctx.calculateTime(
            _ctx.$store.state.GameView.lobby.playthrough.finished,
            _ctx.$store.state.GameView.lobby.playthrough.started,
            _ctx.$store.state.GameView.lobby.playthrough.pauseSum)), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", {
                        class: _normalizeClass({_img:true, _emoji:true, _selected:_ctx.$store.state.GameView.rating===1}),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.rate(1)))
                      }, "😒", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass({_img:true, _emoji:true, _selected:_ctx.$store.state.GameView.rating===3}),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rate(3)))
                      }, "😐", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass({_img:true, _emoji:true, _selected:_ctx.$store.state.GameView.rating===5}),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.rate(5)))
                      }, "😄", 2)
                    ])
                  ])
                ])
              ], 64))
            : (!_ctx.$store.state.GameView.game.doorPasswordEnabled || (_ctx.$store.state.GameView.lobby.playthrough.cardStatus
      && _ctx.$store.state.GameView.lobby.playthrough.cardStatus['door']
      && _ctx.$store.state.GameView.lobby.playthrough.cardStatus['door'].correct))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.$store.state.GameView.game.exitType == 1)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_8, "The chest clicks open!"))
                    : (_openBlock(), _createElementBlock("h3", _hoisted_9, "The door clicks open!")),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$store.state.GameView.game.escapePrompt || "Quick - click it to escape!"), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(_ctx.$store.state.GameView.game.exitPrompt || "This is it!"), 1))
        ]),
        (_ctx.$store.state.GameView.lobby.playthrough.cardStatus && _ctx.$store.state.GameView.game.doorPasswordEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$store.state.GameView.game.doorPasswordClue), 1),
                (!_ctx.$store.state.GameView.lobby.playthrough.cardStatus['door']
        || !_ctx.$store.state.GameView.lobby.playthrough.cardStatus['door'].correct)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_TextInput, {
                          placeholder: "Aa",
                          onChange: _cache[3] || (_cache[3] = ($event: any) => {_ctx.updateAnswer($event); _ctx.focus('door',`question`,$event,null)}),
                          onEnter: _ctx.submit,
                          alert: this.incorrect,
                          "data-focus": `door_question`,
                          onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.focus('door',`question`))),
                          onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.focus('door',`question`,null,null)))
                        }, null, 8, ["onEnter", "alert"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_IconButton, {
                          icon: _ctx.submitted?'loader_spinner':'',
                          loop: _ctx.submitted,
                          autoplay: true,
                          text: "Submit",
                          type: "svg",
                          onClick: _ctx.submit
                        }, null, 8, ["icon", "loop", "onClick"])
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("p", _hoisted_17, [
                      _hoisted_18,
                      _createTextVNode(" " + _toDisplayString(this.$store.state.GameView.game.doorPassword.split(';')[0]), 1)
                    ]))
              ]),
              (_ctx.$store.state.GameView.lobby.playthrough.cardStatus['door'])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.$store.state.GameView.lobby.playthrough.cardStatus['door']?.correct)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_MovingIcon, {
                                name: "tick",
                                type: "svg"
                              })
                            ]),
                            _hoisted_22
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
}